import { format } from 'date-fns';

// The backend serializes timestamps as naive UTC (no timezone offset), e.g.
// "2026-06-11T12:06:55.305164". `new Date(str)` would parse such a string as
// *local* time, so the value would render as the raw UTC wall-clock instead of
// being converted to the viewer's timezone. Appending 'Z' forces UTC parsing;
// date-fns `format` then renders it in the browser's local timezone.
export const parseUtcDate = (value: string | Date): Date => {
  if (value instanceof Date) return value;
  const hasTimezone = /([zZ])|([+-]\d{2}:?\d{2})$/.test(value);
  return new Date(hasTimezone ? value : `${value}Z`);
};

// Safe formatters: return '' for missing/invalid dates instead of throwing.
// date-fns `format` throws RangeError on an Invalid Date, and because entities
// are built inside `.map`, a single bad record would otherwise break the whole
// list (e.g. an order with an empty delivery_date blanking the orders page).
export const formatUtcSafe = (value: string | Date | null | undefined, fmt: string): string => {
  if (!value) return '';
  const date = parseUtcDate(value);
  return Number.isNaN(date.getTime()) ? '' : format(date, fmt);
};

export const formatSafe = (value: string | Date | null | undefined, fmt: string): string => {
  if (!value) return '';
  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? '' : format(date, fmt);
};
